var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#9BA1A0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2812 13.9921C5.2812 11.6568 5.2812 9.34126 5.2812 7.00198C4.84859 7.00198 4.42928 7.00198 4 7.00198C4 6.20901 4 5.43982 4 4.64684C4.05657 4.64288 4.11314 4.63495 4.17304 4.63495C4.48253 4.63495 4.79534 4.62702 5.10483 4.63891C5.24126 4.64288 5.28785 4.59926 5.28453 4.43274C5.27787 3.83008 5.27787 3.23138 5.2812 2.62872C5.28453 1.95072 5.44426 1.33617 5.85025 0.84452C6.24293 0.368734 6.74542 0.111017 7.29118 0.071368C8.16972 0.0118948 9.05158 0.0198244 9.93344 0C9.94343 0 9.95341 0.0118946 9.97338 0.0237892C9.97338 0.820731 9.97338 1.62164 9.97338 2.44237C9.91015 2.44633 9.85025 2.4503 9.79368 2.4503C9.39434 2.4503 8.99501 2.4503 8.59567 2.4503C8.19301 2.45426 7.95674 2.73973 7.95674 3.21155C7.95674 3.65959 7.95674 4.11158 7.96007 4.55961C7.96007 4.57151 7.96672 4.5834 7.9767 4.62702C8.63561 4.62702 9.30116 4.62702 10 4.62702C9.91348 5.43189 9.83361 6.20108 9.74709 6.99802C9.14476 6.99802 8.55574 6.99802 7.95008 6.99802C7.95008 9.34523 7.95008 11.6686 7.95008 14C7.05491 13.9921 6.18303 13.9921 5.2812 13.9921Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.96371725056f86fef0ecd075e473527c.svg";
export { ForwardRef as ReactComponent };